<div
  *ngIf="!newsDetailService.loading"
  class="container"
  [class.no-image]="newsDetailService.hasImages"
>
  <div class="news-detail__container--wrapper col-md-7">
    <div class="flex-column news-detail__container mb-1">
      <news-list-item
        [preloadFirstImage]="true"
        [showAds]="showAds"
        [isDetailView]="true"
        [newsPost]="newsDetailService.newsEntry"
        (openGallery)="onGalleryOpen($event)"
        (textRender)="onTextRender($event)"
      >
      </news-list-item>
      <lib-image-gallery
        #gallery
        (imageChange)="onGalleryImageChange()"
        (galleryClose)="onGalleryClose()"
        [images]="newsDetailService.newsEntry.pictures"
      ></lib-image-gallery>
    </div>
    <div
      *ngIf="consent"
      #taboolaContainer
      class="taboola-widget-container"
      id="taboola-below-article-thumbnails"
    ></div>
    <lib-shop-section [shopItems]="newsDetailService.shopItems"></lib-shop-section>
    <lib-ad *ngIf="showAds" class="my-1"></lib-ad>
    <section class="videos">
      <lib-news-section
        title="Videos"
        titleIcon="play_circle"
        moreButtonTitle="Mehr Videos"
        moreButtonLink="/videos"
        [newsList]="newsDetailService.videos"
        [layout]="newsRowLayout">
      </lib-news-section>
    </section>
    <section
      class="news-list"
    >
      <lib-news-section
        *ngIf="!newsDetailService.topNewsLoading"
        title="Weitere News"
        titleIcon="feed"
        moreButtonTitle="Mehr News"
        moreButtonLink="/news"
        [showMoreButton]="true"
        [newsList]="newsDetailService.topNews"
        [layout]="newsRowLayout">
      </lib-news-section>
      <mat-spinner
        *ngIf="newsDetailService.topNewsLoading"
        strokeWidth="1"
        diameter="32"
        color="primary"
        style="margin: auto"
      ></mat-spinner>
    </section>
    <section class="specials">
      <app-special-card [special]="special"></app-special-card>
    </section>
    <section
      class="news-list"
      inViewport
      *ngIf="
        !newsDetailService.leagueNews || newsDetailService.leagueNews.length > 0
      "
      (inViewportAction)="leagueNewsInViewPort($event)"
    >
      <lib-news-section
        *ngIf="!newsDetailService.leagueNewsLoading"
        title="News: {{newsDetailService.league?.name}}"
        titleIcon="feed"
        moreButtonTitle="Mehr Liga News"
        [moreButtonLink]="newsDetailService.leagueLink + '/news'"
        [newsList]="newsDetailService.leagueNews"
        [layout]="newsRowLayout">
      </lib-news-section>
      <mat-spinner
        *ngIf="newsDetailService.leagueNewsLoading"
        strokeWidth="1"
        diameter="32"
        color="primary"
        style="margin: auto"
      ></mat-spinner>
    </section>
    <app-voucher-code-widget class="voucher-codes"></app-voucher-code-widget>
  </div>
  <div *ngIf="!newsDetailService.loading"
       class="news-detail__table-container col-md-5">
    <lib-league-table [smallTable]="true"
                      [league]="newsDetailService.league"
                      [showSeasonSelect]="false"
                      [highlightTeamId]="newsDetailService.teamId"></lib-league-table>
    <app-current-games [teamId]="newsDetailService.teamId"
                       [leagueId]="newsDetailService.league?.id"></app-current-games>
  </div>
</div>

